module.exports = {"ADV_PROPOSAL_REACTIONS_LIKES_POPOVER_TITLE":"User likes","ADV_PROPOSAL_REACTIONS_DISLIKES_POPOVER_TITLE":"User dislikes"}